export const environment = {
  production: true,
  apiUrl: 'https://execute.noviship.net/api',
  authUrl: 'https://execute.noviship.net/auth',
  release: '3e647e96cf3a39142d43fd65b213d873ec8c0c7b'
};
